import type { ReduxApplicationState } from '../combinedReducer';

export const selectOfferLabelContent = (state: ReduxApplicationState) =>
  state.content.offerLabel || null;
